import { loadImageAsync } from '@/utils/file-kit';
import { createSVGDataURL } from './serialization';

/**
 * 将 SVG 字符串转换为 Canvas 可绘制的图片资源。
 *
 * @param svgText - 完整 SVG 字符串。
 * @returns 加载完成的图片资源。
 */
export const svgToImage = async (svgText: string): Promise<HTMLImageElement> => {
    return loadImageAsync(createSVGDataURL(svgText), false);
};
